import "./cryptoPolyfill";

import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import "./parse";

import { GameProvider } from "./components/header/GameContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <GameProvider>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </GameProvider>
  </BrowserRouter>,
);
